define('view/disclosure/document.action.edit.name.view',['require','exports','module','blockit','uikit/uikit'],function (require, exports, module) {

    var BlocKit = require('blockit');
    var UIKit = require('uikit/uikit');


    var DocumentActionEditFileNameView = UIKit.ItemView.extend({
        template: function () {
            return '<ui name="DocumentNameReadView" /> <ui name="DocumentNameEditableTextFieldView" />';
        },


        internalViewOptions: function () {

            var rowModel = this.getOption('model');

            function cutFileNameToLimit(filename) {

                if(filename && filename.length >= 200 )
                {
                    filename = filename.substr(0, 200)
                }
                return filename;
            }

            return {

                DocumentNameReadView: {
                    type: UIKit.Text,
                    model: rowModel,
                    behaviors: {
                        visibleOnlyInEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                text:
                                    {
                                        formatter: function() {
                                            return cutFileNameToLimit(rowModel.get('name'));
                                         },
                                    },
                                visible: {
                                    formatter: function (rowModel) {
                                        return !rowModel.get('editMode');
                                    },
                                },
                            },
                        },
                    },
                },


                DocumentNameEditableTextFieldView: {
                    type: UIKit.Input,
                    maxLength: 199,
                    rowModel: rowModel,
                    behaviors: {
                        visibleOnlyInEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior.extend({
                                onFirstBeforeRender: function() {

                                    var textFieldView = this.view;
                                    textFieldView.value = rowModel.get('name');

                                    this.listenTo(textFieldView, 'change:value', function(selectedView, enteredText) {
                                        rowModel.set('name', enteredText);
                                    });

                                },

                            }),
                            optionValues: {
                                visible: {
                                    model: rowModel,
                                    formatter: function () {
                                        return this.view.rowModel.get('editMode');
                                    },
                                },
                            },
                        },
                    },
                },


            };
        },
    });

    module.exports = DocumentActionEditFileNameView;
});


